<!-- Product Groups Filters Component -->
<div class="product-groups-filters" [class.drawer-mode]="drawerMode">
  <!-- Header with Filters title and Clear All button -->
  <div class="filters-header-main" [class.p-3]="drawerMode">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-filter text-gray-600 mr-2"></i>
        <h2 class="filters-title">Filters</h2>
      </div>
      <div class="header-right">
        <button
          class="clear-all-btn"
          [disabled]="loading || !hasActiveFilters"
          [class.has-filters]="hasActiveFilters"
          (click)="onClearFilters()"
          title="Clear all active filters"
        >
          Clear All
        </button>
      </div>
    </div>
  </div>

  <!-- Scrollable Filter Content Container -->
  <div
    class="filters-content-scroll"
    [class.drawer-scroll]="drawerMode"
    [class.default-scroll]="!drawerMode"
  >
    <!-- Search Section -->
    <div
      class="search-section"
      [class.px-3]="drawerMode"
      [class.py-3]="drawerMode"
    >
      <div class="search-input-wrapper">
        <p-iconfield iconPosition="left" styleClass="w-full">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            pInputText
            [formControl]="filterForm.controls.search"
            placeholder="Search by name or ID..."
            [disabled]="loading"
            class="modern-search-input w-full"
          />
        </p-iconfield>
      </div>
    </div>
  </div>
</div>
